import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll the window to the top whenever the route pathname changes.
// Skips scrolling when navigating to an in-page hash anchor (e.g. /pilot#scene-3).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);

  return null;
}
